import React, { Component as C } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import styles from "./styles.less"
import dispatchEvent from "@cirrus/legacy/app-components/utils/dispatchEvent.es6"
import appStorage from "@cirrus/legacy/app-components/app-settings/index.es6"
import jss from "jss"
import withSkin from "@cirrus/legacy/app-common/alt/framework/withSkin.jsx"
import v from "@cirrus/legacy/app-components/app/styles/colors/colors-default.less"
import { toJss, darken } from "@cirrus/legacy/app-common/alt/framework/skin/skinUtils.es6"

import HiddenReadableText from "@cirrus/legacy/app-components/readspeaker/hiddenReadableText/index.jsx"
class TablePager extends C {
  static dynamicStyles = null
  static displayName = "TablePager"
  static propTypes = {
    page: PropTypes.number,
    totalPages: PropTypes.number.isRequired,
    onPagerChange: PropTypes.func.isRequired,
  }
  static defaultProps = {
    page: 1,
  }

  constructor(props) {
    super(props)

    if (TablePager.dynamicStyles == null) {
      const dynamicStylesConfig = toJss((props.skinObject.table || {}).pager || {}, {
        easPagination: {
          color: v.gray400,
        },
      })

      TablePager.dynamicStyles = jss.createStyleSheet(dynamicStylesConfig).attach()
    }
  }

  componentDidUpdate() {
    setTimeout(() => dispatchEvent("resize"), 300)
  }

  getPrevPageClass() {
    return classnames(styles.prevPage, "rs_skip", this.props.page == 1 ? styles.disabled : "")
  }

  getNextPageClass() {
    return classnames(
      styles.nextPage,
      "rs_skip",
      this.props.page == this.props.totalPages ? styles.disabled : "",
    )
  }

  onValueChange(e) {
    this.setCurrentPage(Number(e.target.value))
  }

  onNextPage() {
    this.setCurrentPage(this.props.page + 1)
  }

  onPrevPage() {
    this.setCurrentPage(this.props.page - 1)
  }

  setCurrentPage(page) {
    if (!page || page < 1 || page > this.props.totalPages) {
      return
    }

    this.props.onPagerChange(page)
  }

  render() {
    let { classes } = TablePager.dynamicStyles
    let page = appStorage.translationFunction("General:Page")
    let ofTotal = appStorage
      .translationFunction("General:OfTotal")
      .replace("{0}", this.props.totalPages)

    return this.props.totalPages != 1 ? (
      <div
        className={classnames(
          styles.easPagination,
          classes.easPagination,
          "readspeaker-readable-area",
        )}>
        <span>{page}</span>
        <HiddenReadableText text={this.props.page} />
        <input
          className={classnames(styles.formControl, "rs_preserve")}
          value={this.props.page}
          onChange={this.onValueChange.bind(this)}
        />
        <span className="cmn-total-pages">{ofTotal}</span>
        <span className={this.getPrevPageClass()} onClick={this.onPrevPage.bind(this)} />
        <span className={this.getNextPageClass()} onClick={this.onNextPage.bind(this)} />
      </div>
    ) : (
      <div />
    )
  }
}

export default withSkin(TablePager)
